// Word-editor style document surface.
//
// The appraisal submission viewer and the eSign viewers both show a white
// "page" of content. On the app's near-white background that page edge
// disappears, so the form reads as part of the chrome instead of as a document
// (Monday 12817198087). DOC_CANVAS darkens the surrounding area and DOC_PAGE
// lifts the page off it, the way Word/Excel frame a sheet.
export const DOC_CANVAS = "bg-[#CDD3DB]";

export const DOC_PAGE =
  "bg-white border border-gray-300 shadow-[0_2px_12px_rgba(15,23,42,0.16)]";
